import React, { useEffect, useState } from 'react';
import { Button, Dialog, IconButton } from '@material-ui/core';
import { useSelector } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import Spin from 'components/common/Spin';
import Box from '@material-ui/core/Box';
import VideoPlayer from './VideoPlayer';
import { makeStyles } from '@material-ui/core/styles';
import apiClient from 'utils/api-client';
import useSnack from 'hooks/useSnack';
import Typography from '@material-ui/core/Typography';
import uniq from 'lodash/uniq';
import humanDuration from 'humanize-duration';
import Grid from '@material-ui/core/Grid';
import { toUserTimezone } from 'utils';


const useStyles = makeStyles((theme) => ({
  closeIcon: {
    position: 'fixed',
    right: 10,
    top: 10,
  },
  listTitle: {
    color: theme.palette.text.secondary,
    fontWeight: 700,
    textTransform: 'uppercase',
    fontSize: 12,
    marginBottom: theme.spacing(1),
    letterSpacing: 2
  },
}));

const ViewRecording = ({ data, onClose }) => {
  const classes = useStyles();
  const user = useSelector((s) => s.user.user);
  const [videoUrl, setVideoUrl] = useState(null);
  const snack = useSnack();

  useEffect(() => {
    apiClient.get(`/twilio/video/${data.id}/download`).then(
      (resp) => {
        window.analytics.track(`Video recording played`, {
          url: resp.url,
          ...data,
          user
        });
        setVideoUrl(resp.url);
      },
      (e) => {
        snack.error(e.message);
      },
    );
  }, []);

  return (
    <Dialog
      open
      fullScreen
    >
      <IconButton onClick={onClose} className={classes.closeIcon}>
        <CloseIcon />
      </IconButton>
      {!videoUrl && <Spin spinning linear />}
      {videoUrl && (
        <Box padding={2} maxWidth={720} margin="auto" width="100%">
          <Box display="flex" marginBottom={3} justifyContent='space-between'>
            <Box maxWidth={400}>
              <Typography className={classes.listTitle}>Session</Typography>
              <Typography variant="body2">
                Session with{' '}
                {uniq(
                  data.conference_participants.map(
                    (u) =>
                      `${u.user.user_first_name} ${u.user.user_last_name}`,
                  ),
                ).join(', ')}
              </Typography>
            </Box>
            <Box >
              <Typography className={classes.listTitle}>Date</Typography>
              <Typography variant="caption">
                {toUserTimezone(
                  data.created_at,
                  user.timezone,
                ).format('LL')}
              </Typography>
            </Box>
          </Box>
          <Box>
            <VideoPlayer src={videoUrl} user={user} />
          </Box>
          <Box
            textAlign="center"
            paddingTop={14}
            paddingBottom={3}
            onClick={onClose}
          >
            <Button variant="contained" color="primary">
              Close
            </Button>
          </Box>
        </Box>
      )}
    </Dialog>
  )
}

export default ViewRecording;